module.exports = __webpack_public_path__ + "img/artillery-wagon-base-2.1dcef498.png";